import { createContext, useContext, useMemo } from "react";

// Tells pages when the "blocking" layer — the intro overlay on first load or
// the route-transition logo panel on navigation — has lifted, so entrance
// animations can start exactly when the page becomes visible to the visitor
// instead of playing behind the curtain.
const PageRevealContext = createContext({ revealed: true });

export const PageRevealProvider = ({ revealed, children }) => {
  // Stable value identity so consumers only re-render when `revealed` changes.
  const value = useMemo(() => ({ revealed }), [revealed]);
  return <PageRevealContext.Provider value={value}>{children}</PageRevealContext.Provider>;
};

// Hook paired with the provider above (same pattern as contexts/AuthContext).
// eslint-disable-next-line react-refresh/only-export-components
export const usePageRevealed = () => useContext(PageRevealContext);
